export const REGEX = {
  password: /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,16}$/,
  email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,3}$/g,
};
